import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// v3.3.589 — single source of truth for displayed version is package.json
import pkg from "../package.json";

document.title = `نظام إدارة الحجوزات — v${pkg.version}`;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
